function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defaultTheme } from "../../theme/theme";
import { emphasize, makeStyles } from '@material-ui/core/styles';
export var standardSizes = {
  large: {
    width: '340px',
    height: '36px'
  },
  medium: {
    width: '340px',
    height: '32px'
  },
  small: {
    width: '240px',
    height: '28px'
  },
  tiny: {
    width: '94px',
    height: '24px'
  }
};

var _getInputStyles = function _getInputStyles() {
  return {
    height: '100%',
    display: 'flex',
    padding: '0px 4px'
  };
};

var _getListStyles = function _getListStyles(_ref) {
  var variant = _ref.variant,
      size = _ref.size,
      fullWidth = _ref.fullWidth;
  var width = variant === 'standard' ? standardSizes[size].width : '320px';
  return {
    width: fullWidth ? '100%' : width,
    zIndex: 'menu',
    borderRadius: '2px',
    boxShadow: 'active'
  };
};

export var selectStyles = {
  input: function input(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      '& input': {
        font: 'inherit'
      }
    });
  },
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      borderRadius: '2px',
      marginTop: 0,
      marginBottom: 0,
      boxShadow: defaultTheme.shadows.active
    });
  },
  menuList: function menuList(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      borderRadius: '2px',
      paddingTop: 0,
      paddingBottom: 0
    });
  },
  placeholder: function placeholder(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      position: 'relative',
      top: '-8px'
    });
  },
  menuPortal: function menuPortal(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      zIndex: defaultTheme.zIndices.select
    });
  }
};
export var useStyles = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1
    },
    input: _getInputStyles,
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      flexDirection: function flexDirection(_ref2) {
        var variant = _ref2.variant;
        return variant === 'standard' ? 'column' : 'row';
      },
      justifyContent: function justifyContent(_ref3) {
        var variant = _ref3.variant;
        return variant === 'standard' ? 'center' : 'flex-start';
      },
      alignContent: 'flex-start',
      overflow: 'hidden',
      height: 'auto',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    },
    chip: {
      margin: theme.spacing(0.5, 0.25)
    },
    chipFocused: {
      backgroundColor: emphasize(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
    },
    menu: _getListStyles,
    divider: {
      height: theme.spacing(2)
    },
    option: {
      paddingLeft: '12px',
      height: function height(_ref4) {
        var size = _ref4.size;
        return standardSizes[size].height;
      }
    }
  };
});